module.exports = __webpack_public_path__ + "assets/img/icon-badge-60f1534d.png";